import { get } from '@/base/http-base.js'
// demo
export function getCode(params) {
  return get('/api/registry-api/code', params)
}
//获取登录信息
export function getUserInfo(params) {
  return get('/oauth-api/userinfo', params)
}

// 获取用户类型
export function getAccount(params) {
  return get('/basic-api/v1/accountCenter/account', params)
}

//获取用户信息
export function getAccountUserInfo(params) {
  return get('/basic-api/v1/accountCenter/user', params)
}
